export default "__VITE_ASSET__2b206a59__"